import { useContext } from 'react'

import { UiActionRunnerContext } from './UiActionContext'

export function useUiActionRunner() {
  const context = useContext(UiActionRunnerContext)
  if (!context) throw new Error('useUiActionRunner must be used inside UiActionProvider')
  return context
}
